import { render, staticRenderFns } from "./C48Q.vue?vue&type=template&id=437edbc7&scoped=true&"
import script from "./C48Q.vue?vue&type=script&lang=js&"
export * from "./C48Q.vue?vue&type=script&lang=js&"
import style0 from "./C48Q.vue?vue&type=style&index=0&id=437edbc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437edbc7",
  null
  
)

export default component.exports